// eslint-disable-next-line wandb/no-deprecated-imports
import styled from 'styled-components';

export const Header = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 10px;
`;
Header.displayName = 'S.Header';

export const Title = styled.div`
  font-weight: 600;
  font-size: 24px;
  line-height: 48px;
`;
Title.displayName = 'S.Title';

export const Spacer = styled.div`
  flex-grow: 1;
`;
Spacer.displayName = 'S.Spacer';

export const CreateButton = styled.div`
  margin-left: 8px;
`;
CreateButton.displayName = 'S.CreateButton';
